import React, { Component } from 'react'
import { get } from "lodash"

import { checkIsValidCurrentActivity } from "./static.currentActivityData"
import { withStepsState } from "../../../shared/containers/containerStepsState"
import ButtonFill from "../../../shared/items/controls/buttonFill"

class CurrentActivityNextStepButton extends Component {
  componentDidUpdate() {
    const { data, onSetSuccessValidate } = this.props

    if (checkIsValidCurrentActivity(data))
      onSetSuccessValidate("currentActivity")
  }

  render() {
    const { data, onToNextStep } = this.props

    return (
      <ButtonFill disabled={!get(data, ["currentActivity", "isValid"], false)} onClick={onToNextStep}>
        {this.props.children}
      </ButtonFill>
    )
  }
}

export default withStepsState(CurrentActivityNextStepButton)